import { makeStyles } from '@material-ui/core';

const useCountDownTimerStyles = makeStyles((theme) => {
  return ({
    wrapper: {
      display: 'flex',   
      paddingLeft: 'var(--spacing-base-x2)' 
    },
    iconWrapper : {
      padding: '3px' 
    },
    timerMessageWrapper: {
      fontSize: 'var(--h4-text-size)',
    }
  });
});

export default useCountDownTimerStyles;